const KEY_PREFIX = 'primeiros_passos_dismissed_';
const CATEGORIAS_KEY_PREFIX = 'primeiros_passos_categorias_visto_';
const FORCE_KEY_PREFIX = 'primeiros_passos_force_';
const PRESERVE_ON_LOGOUT_EXACT = new Set(['app_version']);
const PRESERVE_ON_LOGOUT_PREFIXES = ['primeiros_passos_', 'prestador_banner_'];

/**
 * Limpa o localStorage no logout, preservando preferências de UX
 * (dismiss dos primeiros passos, dispensa do banner de Modo Prestador) e
 * app_version (evita re-clear do versionEnforcer).
 */
export function clearLocalStorageOnLogout() {
  try {
    const preserved = {};
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (
        PRESERVE_ON_LOGOUT_EXACT.has(key)
        || PRESERVE_ON_LOGOUT_PREFIXES.some((prefix) => key.startsWith(prefix))
      ) {
        preserved[key] = localStorage.getItem(key);
      }
    }
    localStorage.clear();
    Object.entries(preserved).forEach(([key, value]) => {
      if (value != null) localStorage.setItem(key, value);
    });
  } catch {
    try {
      localStorage.clear();
    } catch {
      /* ignore */
    }
  }
}

export function primeirosPassosDismissKey(userId) {
  return `${KEY_PREFIX}${userId ?? 'anon'}`;
}

export function primeirosPassosCategoriasKey(userId) {
  return `${CATEGORIAS_KEY_PREFIX}${userId ?? 'anon'}`;
}

export function primeirosPassosForceKey(userId) {
  return `${FORCE_KEY_PREFIX}${userId ?? 'anon'}`;
}

function emitChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('primeiros-passos-changed'));
  }
}

export function isPrimeirosPassosDismissed(userId) {
  try {
    return localStorage.getItem(primeirosPassosDismissKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function setPrimeirosPassosDismissed(userId, dismissed) {
  try {
    const key = primeirosPassosDismissKey(userId);
    if (dismissed) localStorage.setItem(key, '1');
    else localStorage.removeItem(key);
    if (dismissed) {
      sessionStorage.removeItem(primeirosPassosForceKey(userId));
    }
  } catch {
    /* ignore */
  }
  emitChanged();
}

export function isPrimeirosPassosForced(userId) {
  try {
    return sessionStorage.getItem(primeirosPassosForceKey(userId)) === '1';
  } catch {
    return false;
  }
}

/** Reabre o guia pelo menu — mostra mesmo com passos já concluídos. */
export function restorePrimeirosPassos(userId) {
  try {
    localStorage.removeItem(primeirosPassosDismissKey(userId));
    sessionStorage.setItem(primeirosPassosForceKey(userId), '1');
  } catch {
    /* ignore */
  }
  emitChanged();
}

export function clearPrimeirosPassosForce(userId) {
  try {
    sessionStorage.removeItem(primeirosPassosForceKey(userId));
  } catch {
    /* ignore */
  }
  emitChanged();
}

export function isCategoriasPrimeirosPassosVisto(userId) {
  try {
    return localStorage.getItem(primeirosPassosCategoriasKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function markCategoriasPrimeirosPassosVisto(userId) {
  try {
    localStorage.setItem(primeirosPassosCategoriasKey(userId), '1');
  } catch {
    /* ignore */
  }
  emitChanged();
}
